import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

export enum NotificationType {
  Error = 'Error',
  Success = 'Success',
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  showNotification(type: NotificationType, message: string, action?: string) {
    let panelClass: string;

    switch (type) {
      case NotificationType.Success:
        panelClass = 'notification-success';
        break;
      case NotificationType.Error:
        panelClass = 'notification-error';
        break;
      default:
        panelClass = '';
        break;
    }

    this.snackBar.open(message, action, {
      panelClass: [panelClass],
      duration: 5000,
    });
  }
}
